import { HomePageHero, HomePageStaticBody } from '@components/home'
import React, { useState } from 'react'
import Loading from '@shared/Loading'
import { NeverLostTrack } from '@components/home/NeverLostTrack'

export const HomePageContainer: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)

  return (
    <>
      <style jsx global>{`
        .is-link {
          color: var(--secondary-100);
        }
      `}</style>
      {isLoading && <Loading />}
      <HomePageHero setIsLoading={setIsLoading} />
      <HomePageStaticBody />
      <NeverLostTrack />
    </>
  )
}
